import { RAMP_NS, cs as rampCs, de as rampDe, en as rampEn } from '@ramp/components/locales';
import i18n, { type BackendModule, type ReadCallback } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

// Each locale is its own chunk; only the active one is downloaded.
// The `locale-preload` plugin in vite.config.ts preloads it and copies the detection below: change both together.
const locales: Record<string, () => Promise<{ default: object }>> = {
  en: () => import('./en.json'),
  cs: () => import('./cs.json'),
  de: () => import('./de.json')
};

const localeBackend: BackendModule = {
  type: 'backend',
  init() {},
  read(lng: string, ns: string, callback: ReadCallback) {
    const load = ns === 'translation' ? locales[lng] : undefined;
    if (!load) return callback(null, {});
    load().then(
      module => callback(null, module.default),
      error => callback(error, null)
    );
  }
};

class CustomLanguageDetector extends LanguageDetector {
  detect() {
    let detectedLang = super.detect() ?? [];

    if (typeof detectedLang == 'string') {
      detectedLang = [detectedLang];
    }

    return detectedLang.map(lang => (lang === 'sk' || lang === 'sk-SK' ? 'cs' : lang));
  }
}

export const i18nReady = i18n
  .use(CustomLanguageDetector)
  .use(localeBackend)
  .use(initReactI18next)
  .init({
    debug: true,
    // No en fallback for cs and de: `pnpm check:locales` makes sure they have every en key.
    fallbackLng: { cs: [], de: [], default: ['en'] },
    supportedLngs: ['en', 'cs', 'de'],
    load: 'languageOnly',
    partialBundledLanguages: true,
    defaultNS: 'translation',
    ns: ['translation', RAMP_NS],
    interpolation: {
      escapeValue: false
    },
    resources: {
      en: { [RAMP_NS]: rampEn },
      cs: { [RAMP_NS]: rampCs },
      de: { [RAMP_NS]: rampDe }
    }
  });

export default i18n;
